import axios from 'axios';
import store from '../../store'
import { Toast } from 'vant'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URI,
  withCredentials: false,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    system: 8,
  },
});

service.interceptors.request.use(
  (config) => {
    // ADD TOKEN
    Toast.loading({
      loadingType: 'spinner'
    })
    const loginInfo = store.getters['user/getUser']
    if (loginInfo) {
      config.headers.token = loginInfo.token
      config.headers.uid = loginInfo.uid
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    Toast.clear()
    const code = response.data.code;
    switch (code) {
      case '1':
        return Promise.resolve(response.data.data)
      case '11':
        router.push({
          name: 'Login'
        })
      default:
        return Promise.reject(response.data.msg)
    }
  },
  (error) => {
    console.log('err' + error);
    Toast(error.message);
    return Promise.reject(error.message);
  },
);

export const http = {
  get(url, config) {
    return service.get(url, config);
  },

  post(url, data, config) {
    return service.post(url, data, config);
  },

  put(url, data, config) {
    return service.put(url, data, config);
  },

  delete(url, config) {
    return service.delete(url, config);
  },
};

export default service;
